import { render } from "./PrismaHome.vue?vue&type=template&id=37264b40"
import script from "./PrismaHome.vue?vue&type=script&lang=js"
export * from "./PrismaHome.vue?vue&type=script&lang=js"

import "./PrismaHome.vue?vue&type=style&index=0&id=37264b40&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__